export function isValidEmail(email: string): boolean {
  // Simple HTML5-like pattern; rely on backend for strict validation
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/
  return re.test(String(email || '').toLowerCase())
}

export interface PasswordCheckContext {
  name?: string
  email?: string
}

export interface PasswordCheckResult {
  valid: boolean
  errors: string[]
}

export function validatePasswordStrength(password: string, ctx: PasswordCheckContext = {}): PasswordCheckResult {
  const errors: string[] = []
  const pwd = password || ''
  // Mimic common Django validators reasonably on client side
  // 1) MinimumLengthValidator (default 8)
  if (pwd.length < 8) errors.push('Le mot de passe doit contenir au moins 8 caractères.')
  // 2) NumericPasswordValidator
  if (/^\d+$/.test(pwd)) errors.push('Le mot de passe ne peut pas être uniquement composé de chiffres.')
  // 3) Similarity to user attributes (approximation)
  const lowerPwd = pwd.toLowerCase()
  const parts: string[] = []
  if (ctx.name) parts.push(String(ctx.name))
  if (ctx.email) {
    parts.push(String(ctx.email))
    const local = String(ctx.email).split('@')[0]
    parts.push(local)
  }
  for (const p of parts) {
    const s = String(p || '').toLowerCase()
    if (s && s.length >= 3 && lowerPwd.includes(s)) {
      errors.push("Le mot de passe est trop similaire à vos informations personnelles.")
      break
    }
  }

  return { valid: errors.length === 0, errors }
}
